import React from 'react';
import PropTypes from 'prop-types';
import AcquireWebComponent from '../../framework/MaterialUI';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import { splitNumber } from '../../../utils/utility'

const styles={
	textOverflow :{
		whiteSpace:'nowrap',
		overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '88%'
	}
}
class TopLocationSection extends AcquireWebComponent {
  render() {
    const {data, title} = this.props;
    if (isEmpty(data)){
			return (
				<div style={{ float: "left", width: "100%", position: "relative"}}>
					<div style={{ fontSize: '24px', lineHeight: '18px', fontWeight:'bold' }}>{title}</div>
					<div style={{ width: '100%', minHeight: '338px', textAlign: 'center', paddingTop: '160px', color: "#CDCDCD" }}>
						<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
					</div>		
				</div>
			)
		}else{
      return(
				<div style={{ float: "left", width: "100%", position: "relative" }}>
					<div style={{ fontSize: '24px', lineHeight: '18px', fontWeight:'bold'}}>{title}</div>
          <div style={{ width: '100%', minHeight: '318px', marginTop:"20px"}}>
            {
              map(data, function (obj, idx) {
                return (
                  <div key={"list-" + idx} 
                    className={(idx + 1) === data.length ? "light-grey-border-top light-grey-border-bottom mt-10 pt-15" : 
                      "light-grey-border-top mt-10 pt-15"} 
                    style={{ height: (idx + 1) === data.length ? "54px" : "40px" }}>
                    <div className="pull-left" style={styles.textOverflow}>
                      <span>{obj.link ? <a href={obj.link}>{obj.state}</a>: obj.state}</span>
                    </div>
                    <div className="pull-right">{obj.opens ? splitNumber(obj.opens)() : splitNumber(obj.clicks)()}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      )
    }
  }
}

TopLocationSection.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string.isRequired
}

export default TopLocationSection


// WEBPACK FOOTER //
// ./src/components/Campaigns/Report/TopLocationSection.jsx